import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

const stats = [
  { value: 9, suffix: "+", label: "Years in business" },
  { value: 480, suffix: "+", label: "Local jobs completed" },
  { value: 60, suffix: "+", label: "Landlord & agent clients" },
  { value: 5, decimals: 1, label: "Average review rating" },
];

const Counter = ({ value, suffix = "", decimals = 0 }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState((0).toFixed(decimals));

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setDisplay(v.toFixed(decimals)),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);

  return (
    <span ref={ref}>
      {display}
      {suffix}
    </span>
  );
};

const Stats = () => (
  <section data-testid="stats-section" className="bg-slate-950 py-16 md:py-20">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-6">
        {stats.map((s, i) => (
          <div
            key={s.label}
            data-testid={`stat-${i + 1}`}
            className="lg:border-l lg:first:border-l-0 border-slate-800 lg:pl-8"
          >
            <p className="font-heading text-5xl md:text-6xl font-bold tracking-tight text-white leading-none">
              <Counter value={s.value} suffix={s.suffix} decimals={s.decimals || 0} />
            </p>
            <p className="mt-3 text-sm font-bold uppercase tracking-[0.15em] text-amber-400">
              {s.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
